import { uid } from 'react-uid';

import { SidePanelListNoItemsMessage } from '@dreryk/react-components';

import { HistoricalVisitPrintItem } from './HistoricalVisitPrintItem';
import { HistoricalVisitPrintItemData } from './historicalVisits.types';

type HistoricalVisitPrintsProps = {
   readonly prints: HistoricalVisitPrintItemData[];
};

const HistoricalVisitPrints = (props: HistoricalVisitPrintsProps): JSX.Element => {
   if (!props.prints.length) {
      return <SidePanelListNoItemsMessage message='visit:sidePanel:historicalVisits:historicalVisit:noPrints' />;
   }

   return (
      <>
         {props.prints.map((print, index) => (
            <HistoricalVisitPrintItem print={print} key={uid(print, index)} />
         ))}
      </>
   );
};

export { HistoricalVisitPrints };
